import * as React from 'react';
import {
  Box,
  GDSHeadingLevel,
  GDSIconSource,
  HeadingText,
  Icon as IconComponent,
} from '@leagueplatform/genesis-core';

interface Icon {
  icon?: GDSIconSource | string;
  description?: string;
}

type BenefitsSectionHeaderProps = {
  heading: string;
  headingLevel?: GDSHeadingLevel;
  icon?: Icon;
  id?: string;
};

export function SectionHeaderWithIcon({
  heading,
  headingLevel = '2',
  icon,
  id,
}: BenefitsSectionHeaderProps) {
  const { icon: iconName, description = '' } = icon || {};
  return (
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        gap: '$threeQuarters',
      }}
    >
      {iconName && (
        <Box
          css={{
            display: 'flex',
            alignItems: 'flex-start',
            alignSelf: 'flex-start',
          }}
        >
          <IconComponent
            size="$twoAndHalf"
            icon={iconName}
            label={description}
          />
        </Box>
      )}
      <Box css={{ display: 'flex', alignItems: 'center' }}>
        <HeadingText size="lg" id={id} level={headingLevel}>
          {heading}
        </HeadingText>
      </Box>
    </Box>
  );
}
